import { render, staticRenderFns } from "./RegulationsForm.vue?vue&type=template&id=68cb95e0&"
import script from "./RegulationsForm.vue?vue&type=script&lang=js&"
export * from "./RegulationsForm.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports